import { Component, Inject, OnInit } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '@app/core/config';
import { UtilsService } from '@app/core/services';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'tc-file-upload-limitation-details',
    imports: [
        TranslateModule
    ],
    templateUrl: './file-upload-limitation-details.component.html',
    styleUrls: ['./file-upload-limitation-details.component.scss']
})
export class FileUploadLimitationDetailsComponent implements OnInit {
  allowedExt: string;
  fileMaxSize: number;
  constructor(
    @Inject(APP_CONFIG) private appConfig: IAppConfig,
    private utilsService: UtilsService
  ) { }

  ngOnInit(): void {
    this.allowedExt = this.utilsService.getAllowExtentions(this.appConfig.allowFileExtentions).replace('.', '');
    this.setMaxSize();
  }

  private setMaxSize(): void {
    let mbMaxSize = (this.appConfig.fileUploadSize / 1048578);
    if ((mbMaxSize % 1) != 0) {
      mbMaxSize = parseFloat(mbMaxSize.toFixed(2));
    }
    this.fileMaxSize = mbMaxSize;
  }

}
